import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import ColumnSelectionPopup from '../../../components/data-collections/column-selection-popup/column-selection-popup'
import BasicInformationController from '../add-new-data-collection/basic-information/basic-information-controller';
import * as collectionService from '../../../services/data-collection.service';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { testData } from '../../../services/test-data.service';
import { getDateRange } from './date-filter-controller/date-filter-helper';
import { DataTypePriorityMap, getEquivalentPriorityDataType } from '../add-new-data-collection/select-columns/datatypes-equivalent-map';
import { toast } from 'react-toastify';
import { closeIFrameDialog } from '../../../components/asheetPlugin/utils2/common-code';
import { formatDisplayName } from '../utils/template-collection-parameter';
import { AppEnum } from '../../../constants/app-enum';
import { setPluginChange } from '../../../services/authCallback-service';
import { defaultJavaScriptEditorValue } from './cloud-data-script/cloud-data-script-controller';
import * as dataScriptService from '../../../services/data-script.service';
import MuiDialog from '../../../shared/mui-dialog/mui-dialog';
import { useSelector } from 'react-redux';

export default function ColumnSelectionController(props) {

    const { getColumnSchema, state, resetErrorMessages, setState, prevStepRef, getCollectionDetails,
        setSelectedConnection, saveCollection, isBasicInfoSubmitted, setActiveStep, activeStep, isUpdatingCollection,
        isLoading, setIsLoading, selectedConnection, getCollectionObjectByType, prevCloudFilterationData, isCloudFilterationData,
        setIsCloudFilterationData,queryState,isOpenInDialog = true, handleAuthorizeAgain, isAuthorizeAgain, setCollectionType,
        isSearchOptionsAvailable, collectionTypeTemplate, searchOptionsParameters, setSearchOptionsParameters, previousChildCompanyUID,
        setShowDataVisualizer, showDataVisualizer, maunalColumns, columnOverriden, setColumnOverriden, prevCloudTransformationScripts, excelDataState, setExcelDataState} = props;


    const [columnsList, setColumnList] = useState([]);
    const [filterColumnsList, setFilterColumnsList] = useState([]);
    const [data, setData] = useState([]);
    const [sortModal, setSortModal] = useState(false);
    const [filterModal, setFilterModal] = useState(false);
    const [limitModal, setLimitModal] = useState(false);
    const [sortData, setSortData] = useState([]);
    const [limitData, setLimitData] = useState(null);
    const [currentSortIndex, setCurrentSortIndex] = useState();
    const [sortInput, setSortInput] = useState({
        orderBy: "",
        field: ""
    })
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [preview, setPreview] = useState(false);
    const [filterData, setFilterData] = useState([]);    
    const [isNewColumFilter, setIsNewColumFilter] = useState(false);
    const [filterConfig, setFilterConfig] = useState({
        numberOfFilterGroupAllowed: 0,
        numberOfFilterPerGroupAllowed: 0,
        numberOfSortAllowed: 0,
        operatorAllowedInFilterGroup: [],
        operatorAllowedInFilter: [],
        filterTypeArray: [],
        filterGroupExceeded: "",
        filterPerGroupExceeded: "",
        SortExceeded: ""
    });
    const [prevFilterationData, setPrevFilterationData] = useState({
        prevFilterData: [],
        prevSortData: [],
        prevLimitData: null,
        templateCollectionId: null,
        childTemplateInheritedCollectionId : null
    });
    const [collectionFilterColumns, setCollectionFilterColumns] = useState([]);
    const [isColumnOrderChanged, setIsColumnOrderChanged] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [selectedSearchButton, setSelectedSearchButton] = useState(0);
    const { collectionUId: collectionUId } = useParams();
    const searchInputRef = useRef(null);
    const navigate = useNavigate();

    const [openPopup, setOpenPopup] = useState(false);        
    const [customColumn, setCustomColumn] = useState();
    const [datatypeDisplayFormate, setDatatypeDisplayFormate] = useState();
    const [prioritizeEquivalentDataTypes, setPrioritizeEquivalentDataTypes] = useState();
    const [isDynamicTestCollectionTested, setIsDynamicTestCollectionTested] = useState(false);
    const [openDataScriptPopup, setOpenDataScriptPopup] = useState(false);
    const [cloudDataScriptType, setCloudDataScriptType] = useState(null)
    const [testedData, setTestedData] = useState({
        transformedData: [],
        transformedDataColunmsKey: [],
        styleTransformedData: [],
        styleTransformedDataColunmsKey: [],
    })
    const [preDefinedScriptsData, setPreDefinedScriptsData] = useState();
    const [muiDialog, setMuiDialog] = useState(false);
    const [isParameterPopulated, setIsParameterPopulated] = useState(false);
    const isGoogleSheetPluginActive = useSelector((state) => state.pluginState?.isGoogleSheetPluginActive);
    const [isSchemaChangedByScript, setIsSchemaChangedByScript] = useState(false);
    const previousState = useRef(null);
    const [callExecuteData, setCallExecuteData] = useState(false);

    useEffect(()=>{
        setPrioritizeEquivalentDataTypes(getEquivalentPriorityDataType(state?.displayFormatList));
    },[state?.displayFormatList])    

    useEffect(() => {
        const prevData = prevCloudFilterationData?.templateCollectionId ? prevCloudFilterationData : prevFilterationData;
        if (collectionUId && ((state?.templateCollectionId === prevData?.templateCollectionId && prevData?.childTemplateInheritedCollectionId === state?.childTemplateInheritedCollectionId) ||
            (state?.templateCollectionId === prevData?.templateCollectionId && !prevData?.childTemplateInheritedCollectionId))) {

            if (prevData?.prevFilterData?.length > 0) {
                setFilterData(prevData?.prevFilterData);
            }
            if (prevData?.prevSortData?.length > 0) {
                setSortData(prevData?.prevSortData);
            }
            if (prevData?.prevLimitData) {
                setLimitData(prevData?.prevLimitData);
            }
            setIsNewColumFilter(true);
            setIsCloudFilterationData(true);
        }
    }, [])

    useEffect(() => {
        if (!isSearchOptionsAvailable) {
            setSelectedSearchButton(1);
        }
        else {
            setSelectedSearchButton(0);
        }
    }, [isSearchOptionsAvailable])

    const fetchData = useCallback(async () => {
        let response = true;
        const currentUID = state?.childCompanyCollectionUId;
        if (currentUID && previousChildCompanyUID.current !== currentUID) {
            response = false;
            previousChildCompanyUID.current = currentUID;
            response = await getCollectionDetails(currentUID);
        }
    
        if (previousState.current !== state && state?.templateCollectionId !== null && response) {           
            await getColumnSchema(state, formatColumList);
            previousChildCompanyUID.current = null;
        }
    
        previousState.current = state;
    }, [state?.childCompanyCollectionUId, state?.templateCollectionId]);
    
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        if (state?.collectionParameters.length > 0 && !isNewColumFilter && !isCloudFilterationData) {
            var filterParameter = state?.collectionParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.filter);
            var sortParameter = state?.collectionParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.sort);
            var limitParameter = state?.collectionParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.limit);

            if (filterParameter && filterParameter?.length > 0) {
                var filter = JSON.parse(filterParameter[0].defaultValue);
                filter = filter.filter(group => group.filters.length > 0);

                filter.forEach((group) => {
                    group.filters.forEach((filter) => {
                        if (filter.dateLabelValue) {
                            const { startDate, endDate } = getDateRange(filter.dateLabelValue, filter?.conditionLabel);
                            if (startDate && endDate) {
                                filter.value = startDate;
                                filter.highValue = endDate;
                            }
                        }
                    });
                });

                setFilterData(filter);
                if (collectionUId && !prevFilterationData?.templateCollectionId) {
                    setPrevFilterationData(prevState => ({
                        ...prevState,
                        prevFilterData: filter,
                        templateCollectionId: state?.templateCollectionId,
                        childTemplateInheritedCollectionId : state?.childTemplateInheritedCollectionId
                    }));
                }
            }
            if (sortParameter && sortParameter?.length > 0) {
                var sort = JSON.parse(sortParameter[0].defaultValue);
                setSortData(sort);

                if (collectionUId && !prevFilterationData?.templateCollectionId) {
                    setPrevFilterationData(prevState => ({
                        ...prevState,
                        prevSortData: sort,
                        templateCollectionId: state?.templateCollectionId,
                        childTemplateInheritedCollectionId : state?.childTemplateInheritedCollectionId
                    }));
                }
            }
            if (limitParameter && limitParameter?.length > 0) {
                var limit = JSON.parse(limitParameter[0].defaultValue);
                setLimitData(limit);

                if (collectionUId && !prevFilterationData?.templateCollectionId) {
                    setPrevFilterationData(prevState => ({
                        ...prevState,
                        prevLimitData: limit,
                        templateCollectionId: state?.templateCollectionId,
                        childTemplateInheritedCollectionId : state?.childTemplateInheritedCollectionId
                    }));
                }
            }
            setIsNewColumFilter(true);
            setIsCloudFilterationData(true);
        }
    }, [state?.collectionParameters])


    useEffect(() => {
        const hasChildCompany = !!state?.childCompanyCollectionUId;
        const hasColumns = (state?.collectionColumnSchema?.length > 0) && (state?.collectionColumns?.length > 0);
        const shouldExecute = hasChildCompany && hasColumns && callExecuteData && !isColumnOrderChanged;
    
        if (shouldExecute) {
            setCallExecuteData(false);
            setTimeout(() => executeData(false), 200);
        }
    }, [columnsList, isParameterPopulated]);

    useEffect(() => {
        if (state?.collectionColumnSchema && state?.collectionColumnSchema.length > 0 && !isColumnOrderChanged && !isDynamicTestCollectionTested && (isParameterPopulated || !(searchOptionsParameters || []).some(i => i.sysDataTypeId == AppEnum.DataTypeId.DynamicList)) && !isSchemaChangedByScript) {
            executeData(false);            
        }
        setIsSchemaChangedByScript(false);
    }, [columnsList, isParameterPopulated])

    useEffect(() => {
        if ((selectedConnection && !state?.templateCollectionId) || collectionUId) {
            getCollectionObjectByType();
            getCollectionObjectByType(AppEnum.CollectionType.FromChildTemplate);
        }
    }, [collectionUId]);

    useEffect(() => {
        if (selectedConnection?.connectionTypeId) {
            getCollectionFilterConfig(selectedConnection?.connectionTypeId);
        }
    }, [selectedConnection])

    useEffect(() => {
        getCollectionFilterColunms();
        getCollectionScripts();
    }, [])    

    useEffect(() => {
        if(state?.cloudCollectionError && state?.cloudCollectionError?.data?.data?.access_token){
            getColumnSchema(state, formatColumList);
            setState((prevState) => { return { ...prevState, cloudCollectionError: null } });
        }
    }, [state?.cloudCollectionError])

    useEffect(()=>{
        if(maunalColumns.length > 0 && columnsList.length > 0 && columnOverriden){

            maunalColumns.forEach((manualColumn) => {
                let column = columnsList.find((col) => col.columnName === manualColumn.columnName);
            
                if (column) {
                    Object.assign(column, {
                        displayName: column.displayName,
                        isSelected: column.isSelected || false,
                        dataTypeName: column.dataTypeName, 
                        isManuallyCreated: true,
                        displayFormat: column.displayFormat || manualColumn.displayFormat,
                        isDefault: manualColumn.isDefault,
                        isFilterable: manualColumn.isFilterable,
                        isSortable: manualColumn.isSortable,
                        notQuerable: manualColumn.notQuerable,
                        displayOrder: column.displayOrder,
                        isAutoDeleted: column.isAutoDeleted,
                        isAutoPopulated: column.isAutoPopulated
                    });
                }
            });
            

            const sortedColumnsList = _.orderBy(columnsList,['isSelected', (col) => col?.displayName?.toLowerCase()],['desc', 'asc']);

            setColumnOverriden(false);

            setColumnList(sortedColumnsList);
        }

    },[maunalColumns,columnsList])

    useEffect(() => {
        if (state.testedDataList.length > 0) {
            
            if (( (state?.cloudDataTransformationScript != null && state?.cloudDataTransformationScript !== defaultJavaScriptEditorValue && columnsList) || state?.dataTransformationScriptId )){
                // if (testedData?.transformedData?.length == 0) {
                    handleTestScript(null, AppEnum.DataScript.dataTransformationScript)
                // }
            }
            if (( (state?.dataStylingScript != null && state?.dataStylingScript !== defaultJavaScriptEditorValue) || state?.dataStylingScriptId)) {
                // if (testedData?.styleTransformedData?.length == 0) {
                    handleTestScript(null, AppEnum.DataScript.dataStylingScript)
                // }
            }
        }
    }, [state.testedDataList])

    const getCollectionFilterColunms = () => {
        collectionService.getCollectionFilterColumns()
            .then((response) => {
                if (response?.data) {
                    setCollectionFilterColumns(response?.data);
                }
            })
    }

    const dataForStyleScript = useMemo(() => {
        if (!testedData?.transformedData?.length) {
            return state?.testedDataList || [];
        } else {
            return testedData.transformedData;
        }
    }, [testedData?.transformedData, state?.testedDataList]);



    const getCollectionFilterConfig = (connectionTypeId) => {
        collectionService.getCollectionFilterConfig(connectionTypeId)
            .then((response) => {
                if (response?.data) {
                    setFilterConfig({
                        numberOfFilterGroupAllowed: response.data?.numberOfFilterGroupAllowed,
                        numberOfFilterPerGroupAllowed: response.data?.numberOfFilterPerGroupAllowed,
                        numberOfSortAllowed: response.data?.numberOfSortAllowed,
                        operatorAllowedInFilterGroup: response.data?.operatorAllowedInFilterGroup,
                        operatorAllowedInFilter: response.data?.operatorAllowedInFilter,
                        filterTypeArray: response.data?.filterTypeArray,
                        filterGroupExceeded: response.data?.filterGroupExceeded,
                        filterPerGroupExceeded: response.data?.filterPerGroupExceeded,
                        SortExceeded: response.data?.sortExceeded
                    });
                }
            })
    }

    const formatColumList = (data, isDynamicColumns = false) => {
        if (data) {
            var columns = data?.map((i) => {
                return {
                    columnName: i.columnName,
                    displayName: i.displayName,
                    isFilterable: i.isFilterable,
                    isSortable: i.isSortable,
                    isDefault: i.isDefault,
                    //isSelected: i.isSelected || isDynamicColumns,
                    isSelected: i.isSelected,
                    dataTypeName: i.dataTypeName,
                    displayFormat: i.displayFormat,
                    isMultiSelect: i.isMultiSelect,
                    options: i.options,
                    notQuerable: i.notQuerable,
                    displayOrder : i.displayOrder,
                    isManuallyCreated : false,
                    isAutoPopulated : i.isAutoPopulated,
                    isAutoDeleted : i.isAutoDeleted
                }
            });
            setState((prevState) => { return { ...prevState, collectionColumnSchema: columns } });

            setIsColumnOrderChanged(false);
            const sortedList = _.orderBy(columns,[(col) => col?.isAutoPopulated ? 1 : 0, 'isSelected', (col) => col?.displayName?.toLowerCase()],['asc', 'desc', 'asc']);
            setColumnList(sortedList);
        }
        return [];
    }

    const formateFilterData = () => {
        var colParameters = [...state?.collectionParameters];
        if (filterData?.length > 0) {
            if (colParameters?.length > 0 && colParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.filter).length > 0) {
                var prevCollectionParameter = colParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.filter);
                if (prevCollectionParameter.length > 0) {
                    prevCollectionParameter[0].defaultValue = JSON.stringify(filterData?.filter(group => group.filters.length > 0));
                }
            }
            else {
                let collectionParameter = {
                    parameterName: AppEnum.ReservedKeywords.filter,
                    sysDataTypeID: null,
                    defaultValue: JSON.stringify(filterData?.filter(group => group.filters.length > 0)),
                    displayName: "Filter",
                    isFixed: false,
                    description: "",
                    listColumnValue: "",
                    listColumnLabel: "",
                    isMultiSelectList: false,
                    dynamicListCollectionID: 0,
                    fixedListVariableId: 0,
                    parameterTypeCD: "",
                    inputFieldTypeCD: "",
                    sendAs: null,
                    variableUId: null,
                    isOptionalParameter: false,
                    enableSavingParameterValue: false,
                }

                colParameters.push(collectionParameter);
            }

            setState((prevState) => { return { ...prevState, collectionParameters: colParameters } });
        }

        if (sortData.length > 0) {
            if (colParameters?.length > 0 && colParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.sort).length > 0) {
                var prevCollectionParameter = colParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.sort);
                prevCollectionParameter[0].defaultValue = JSON.stringify(sortData);
            }
            else {
                let collectionParameter = {
                    parameterName: AppEnum.ReservedKeywords.sort,
                    sysDataTypeID: null,
                    defaultValue: JSON.stringify(sortData),
                    displayName: "Sort",
                    isFixed: false,
                    description: "",
                    listColumnValue: "",
                    listColumnLabel: "",
                    isMultiSelectList: false,
                    dynamicListCollectionID: 0,
                    fixedListVariableId: 0,
                    parameterTypeCD: "",
                    inputFieldTypeCD: "",
                    sendAs: null,
                    variableUId: null,
                    isOptionalParameter: false,
                    enableSavingParameterValue: false,
                }

                colParameters.push(collectionParameter);
            }

            setState((prevState) => { return { ...prevState, collectionParameters: colParameters } });
        }

        if (limitData) {
            if (colParameters?.length > 0 && colParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.limit).length > 0) {
                var prevCollectionParameter = colParameters.filter(i => i.parameterName == AppEnum.ReservedKeywords.limit);
                prevCollectionParameter[0].defaultValue = JSON.stringify(limitData);
            }
            else {
                let collectionParameter = {
                    parameterName: AppEnum.ReservedKeywords.limit,
                    sysDataTypeID: null,
                    defaultValue: JSON.stringify(limitData),
                    displayName: "Limit",
                    isFixed: false,
                    description: "",
                    listColumnValue: "",
                    listColumnLabel: "",
                    isMultiSelectList: false,
                    dynamicListCollectionID: 0,
                    fixedListVariableId: 0,
                    parameterTypeCD: "",
                    inputFieldTypeCD: "",
                    sendAs: null,
                    variableUId: null,
                    isOptionalParameter: false,
                    enableSavingParameterValue: false,
                }

                colParameters.push(collectionParameter);
            }

            setState((prevState) => { return { ...prevState, collectionParameters: colParameters } });
        }
    };

    const handleOnChangeSelectColumn = (event, index, item) => {

        var newSelectedList = [...columnsList]
        var newFilteredList = [...filterColumnsList]
        
        if (item && newFilteredList?.length == 0) {
            var updatedIndex = newSelectedList.findIndex(i => i.columnName === item.columnName);
            index = updatedIndex;
        }

        if (!preview) {
            // let hasColumnData = true;
            // if ((index == null || index == undefined) && !item && event.target.checked) {
            //     const selectedColumnNames = newSelectedList.map(column => column.columnName);

            //     const allColumnsPresent = selectedColumnNames.every(columnName => {
            //         return state?.testedDataList?.some(dataRow => columnName in dataRow);
            //     });
            
            //     hasColumnData = allColumnsPresent;
            // }
            // else {
            //     hasColumnData = item && state?.testedDataList?.some(data => Object.keys(data)?.includes(item?.columnName));
            // }

            // hasColumnData = !event.target.checked ? true : hasColumnData
            // setPreview(!hasColumnData);
            setPreview(true);
        }
        
        let originalIndex = null;
        if (newFilteredList?.length > 0) {
            const columnInFilteredList = newFilteredList[index];
            originalIndex = newSelectedList?.findIndex(i => i.columnName === columnInFilteredList?.columnName);
        }
        let selectedColumnDisplayOrder = 0;
        if (index == null || index == undefined) {
            if (event.target.checked) {
                newSelectedList = newSelectedList.map((i) => {
                    i.isSelected = true;
                    return i;
                })
            }
            else {
                newSelectedList = newSelectedList.map((i) => {
                    if (i.isAutoPopulated) {
                        return {...i, isSelected: true}
                    }
                    i.isSelected = false;
                    i.displayOrder = 0;
                    return i;
                })
            }
        }
        else {
            let targetIndex = (originalIndex && originalIndex != null) ? originalIndex : index;
            selectedColumnDisplayOrder = newSelectedList[targetIndex].displayOrder;
            newSelectedList[targetIndex].isSelected = event.target.checked;
            newSelectedList[targetIndex].displayOrder = 0;            
        }

        if (newFilteredList?.length > 0) {
            if (index == null || index == undefined) {
                if (event.target.checked) {
                    newFilteredList = newFilteredList.map((i) => {
                        i.isSelected = true;
                        return i;
                    })
                }
                else {
                    newFilteredList = newFilteredList.map((i) => {
                        i.isSelected = false;
                        return i;
                    })
                }
            }
            else {
                newFilteredList[index].isSelected = event.target.checked;
            }
            setFilterColumnsList(newFilteredList);
        }

        let checkSelected  = newSelectedList.some(i => i.isSelected);
        let maxDisplayOrder = checkSelected ? Math.max(...newSelectedList.filter(i => i.isSelected).map(i => i.displayOrder || 0)) : 0;

        if (maxDisplayOrder !== 0){
            let increment = 1;
            newSelectedList = newSelectedList.map(i => {
                if(selectedColumnDisplayOrder !== 0 && selectedColumnDisplayOrder == maxDisplayOrder){
                    return i;
                }
                else if(selectedColumnDisplayOrder !== 0 && selectedColumnDisplayOrder < maxDisplayOrder){
                    if(i.displayOrder !== 0 && i.displayOrder > selectedColumnDisplayOrder){
                        return { ...i, displayOrder: --i.displayOrder };
                    }
                    return i;
                }
                else if (i.isSelected && (i.displayOrder == undefined || i.displayOrder == null || i.displayOrder == 0)) {
                    const updatedColumn = { ...i, displayOrder: maxDisplayOrder + increment };
                    increment++;
                    return updatedColumn;
                }                
                return i;
            });
        }
        else if(maxDisplayOrder == 0 && checkSelected){
            let increment = 1;
            newSelectedList = newSelectedList.map(i => {                
                if (i.isSelected) {
                    return { ...i, displayOrder: increment++ };
                }
                return i;
            });
        }

        setIsColumnOrderChanged(false);
        setColumnList(newSelectedList);
        setState((prevState) => { return { ...prevState, collectionColumnSchema: newSelectedList } });

    }

    const executeData = (previewTrue = false) => {
        if (preview && !previewTrue) {
            return;
        }
        else if (preview && previewTrue) {
            setPreview(false);
        }

        setSearchValue('');
        setFilterColumnsList([]);
        if (searchInputRef?.current) {
            searchInputRef.current.value = '';
        }

        setIsLoading(true);

        setState((prevState) => { return { ...prevState, isTestingConnection: true, restBody: JSON.stringify(filterData) } });
        resetErrorMessages();

        var cloudCollectionObject = state.cloudCollectionObjects.filter(obj => obj.templateCollectionId === state.templateCollectionId)[0];

        let testDataCollectionModal = {
            connectionUId: state.connectionUId,
            sysCollectionTypeId: state.sysCollectionTypeId,
            sourceName: state.sourceName,
            restRequestMethod: state.restRequestMethod,
            restRequestIsAsync: true,
            restSendAsCD: state.restSendAsCD,
            collectionParameters: isSearchOptionsAvailable ? searchOptionsParameters : state?.collectionParameters,
            collectionColumns: preview ? state?.collectionColumnSchema?.filter((i) => i.isSelected) : columnsList?.filter((i) => i.isSelected),
            uId: state.uId,
            returnFlatternData: !cloudCollectionObject?.returnRawData,
            sourceNamePart4: state.sourceNamePart4,
            templateCollectionId: state.templateCollectionId,
            collectionFilters: getFilterData(),
            collectionSorts: sortData,
            collectionLimit: limitData,
            restDataTransformationScript : state?.restDataTransformationScript,
            returnRawData : cloudCollectionObject?.returnRawData,
            connectionId : selectedConnection?.id,
            savedParameterValue: state.savedParameterValue,
            flattenLikeSql: cloudCollectionObject?.flattenLikeSql || false,
            excludedProperties: cloudCollectionObject?.excludedProperties || "",
            selectedConnection: selectedConnection,
        }

        formateFilterData();

        testData(testDataCollectionModal,setData,null,null,true,setState,setIsLoading,true,null,null,null,state?.collectionColumnSchema ? state?.collectionColumnSchema?.filter(i => i.isDefault || i.isSelected) : state?.collectionColumns, formatColumList, setIsDynamicTestCollectionTested, handleSendDataToExcel);

    };

    const getFilterData = () => {
        const filterGroups = filterData?.map(group => {
            const filters = group?.filters.map(item => ({
                field: item.field,
                value: item.value,
                operator: item.operator,
                condition: item.condition,
                displayName: item.displayName,
                highValue: item.highValue,
                values: item.values,
                dateLabel: item.dateLabel,
                dataTypeName: item.dataTypeName,
                valueLabel: item.valueLabel,
                dateLabelValue: item.dateLabelValue,
                conditionLabel: item.conditionLabel,
                isMultiSelect: item.isMultiSelect,
            }));
            return { filters: filters, operator: group?.operator };
        });

        if (!filterGroups || filterGroups.length === 0) {
            return [];
        }

        return [{ filterGroups: filterGroups }];
    };

    const openSortModal = () => {
        setSortModal(true);
        setFilterModal(false)
        setLimitModal(false)
    }

    const closeSortModal = () => {
        setSortModal(false);
    }

    const openFilterModal = () => {
        setFilterModal(true);
        setSortModal(false);
        setLimitModal(false)
    }

    const closeFilterModal = () => {
        setFilterModal(false);
    }

    const openLimitModal = () => {
        setLimitModal(true)
        setFilterModal(false);
        setSortModal(false);
    }

    const closeLimitModal = () => {
        setLimitModal(false)
    }

    const handleChangeObject = async (isCrossIconClick) => {
        if (excelDataState?.isCommandFromExcel && window.chrome && window.chrome.webview && isCrossIconClick) { //for excel popup close
            window.chrome?.webview?.postMessage('close_window')
        }
        if(isGoogleSheetPluginActive){
        const data ={
            state : state?.uId,
            code : "close_window"
        }
            await setPluginChange(data);
            closeIFrameDialog('closeDialog')
        }

        if(showDataVisualizer){
            setShowDataVisualizer(false);
            return;
        }
        else if (queryState?.isForDataCollections){
            navigate(-1);
            return;
        }
        else if(queryState?.CloseWindowOnPopupClose){
            window.close();
        }
        else {
            setActiveStep(activeStep - 1)
        }
    }

    const onChangeSortInputs = (event, input) => {
        if (input == "order") {
            setSortInput((prevState) => {
                return { ...prevState, orderBy: event.target.value }
            });
        }
        else {
            setSortInput((prevState) => {
                return { ...prevState, field: event.target.value }
            });
        }
    }

    const addSort = () => {
        var newSortData = [...sortData];

        if (currentSortIndex != null) {
            newSortData[currentSortIndex].orderBy = sortInput.orderBy;
            newSortData[currentSortIndex].field = sortInput.field;

            setCurrentSortIndex(null);
        }
        else {
            newSortData.push(sortInput);
        }

        setSortData(newSortData);

        setSortInput((prevState) => {
            return { ...prevState, field: "", orderBy: "" }
        });

        setSortModal(false);
    };

    const handleDeleteSort = (index) => {
        var newSortData = [...sortData];
        newSortData.splice(index, 1);
        setSortData(newSortData);
    }

    const handleClickSort = (index) => {
        var currentSortdata = sortData[index];
        setSortInput(currentSortdata);
        setCurrentSortIndex(index)
        setSortModal(true);
    }

    const handleSaveCollection = async (flag) => {
        await saveCollection();
        const stateJson = JSON.stringify(searchOptionsParameters)
        const data ={
            state : state?.uId,
            code : stateJson
        }
  
        await setPluginChange(data);
        

        setTimeout(() => {
            closeIFrameDialog(flag ? '':'closeDialog')
            
        }, 500);

    }


    const handleSave = async () => {
        if (collectionUId || queryState?.CollectionUId) {
            
            
        
            if (excelDataState?.isCommandFromExcel && excelDataState?.isEditMode) {
                executedData(true);
            }
            handleSaveCollection();
        }
        else {
            setIsDialogOpen(true)
        }
       

    }

    const clearModels = () =>{
        setFilterData([]);
        setSortData([]);
        setLimitData(null);
        closeFilterModal();
        closeSortModal();
        closeLimitModal();
    }

    const handleObjectChange = async(event, prevCloudObjectUId) => {       
        let changedTemplateCollectionId = event ? event.target.value : state?.templateCollectionId;
        let collectionObjects;
        if(state?.cloudCollectionObjects && state?.childTemplateCollectionObjects){
            collectionObjects = [
                ...(state?.cloudCollectionObjects || []), 
                ...(state?.childTemplateCollectionObjects || [])
            ];
        }
        let object = collectionObjects?.find(i => i.templateCollectionId == changedTemplateCollectionId);
        const checkCollectionType = object?.childTemplateCollectionId !== 0 ? true : false;
        const collectionType = checkCollectionType ? AppEnum.CollectionType.FromChildTemplate : AppEnum.CollectionType.FromScratch            
        setCollectionType(collectionType);
        clearModels();
        setCallExecuteData(true);
        
        if (object) {
            const prevData = prevFilterationData?.templateCollectionId ? prevFilterationData: prevCloudFilterationData;

            setState((prevState) => { 
                const { dynamicListCollectionModel, dynamicListOptions, uId, ...rest } = prevState;
                return { 
                  ...rest, restBody : "", cloudObjectChanged : true,
                  collectionColumnSchema : [], collectionColumns : [], collectionParameters: [],
                  childCompanyCollectionUId: checkCollectionType ? object?.templateCollectionUId : null,
                  collId: checkCollectionType ? object?.childTemplateCollectionId : null,
                  templateCollectionId: object?.templateCollectionId,
                  savedParameterValue : "", childTemplateInheritedCollectionId : null,
                  childTemplateCollectionId : checkCollectionType ? object?.templateCollectionId : null,
                  restDataTransformationScript: object?.restDataTransformationScript,
                };
              });
            if (prevData?.templateCollectionId) {
                if((checkCollectionType && object?.childTemplateCollectionId === prevData?.templateCollectionId &&
                    prevData?.childTemplateInheritedCollectionId === object?.templateCollectionId) ||
                    (!checkCollectionType && object?.templateCollectionId === prevData?.templateCollectionId && !prevData?.childTemplateInheritedCollectionId)){
                    if (prevData?.prevFilterData?.length > 0) {
                        setFilterData(prevData?.prevFilterData);
                    }
                    if (prevData?.prevSortData?.length > 0) {
                        setSortData(prevData?.prevSortData);
                    }
                    if (prevData?.prevLimitData) {
                        setLimitData(prevData?.prevLimitData);
                    }
                    setIsNewColumFilter(true);
                    setIsCloudFilterationData(true);
                }
                else{
                    setIsNewColumFilter(false);
                    setIsCloudFilterationData(false);
                }                
            }
           
            if (prevCloudTransformationScripts?.templateCollectionId) {
                const prevScriptCheck = prevCloudTransformationScripts?.templateCollectionId !== object?.templateCollectionId;

                setState((prevState) => { return {...prevState,
                    cloudDataTransformationScript : prevScriptCheck ? null : prevCloudTransformationScripts?.transformationScript,
                    dataStylingScript : prevScriptCheck ? null : prevCloudTransformationScripts?.stylingScript,
                    dataTransformationScriptId : prevScriptCheck ? null : prevCloudTransformationScripts?.transformationScriptId,
                    dataStylingScriptId : prevScriptCheck ? null : prevCloudTransformationScripts?.stylingScriptId
                }})
            }
            
            if(!checkCollectionType){
                setState((prevState) => { return {...prevState,
                    cloudDataTransformationScript : null,
                    dataStylingScript : null,
                    dataTransformationScriptId : null,
                    dataStylingScriptId : null
                }}) 
            }
        }
    }

    const onSearchHandler = (e) => {
        let searchedKey = e.target.value
        setSearchValue(searchedKey);
        resetErrorMessages();

        let filteredDataColunmList = [];
        let searchedColunmList = [];

        if (searchedKey) {
            filteredDataColunmList = columnsList;
            searchedColunmList = [];

            _.forEach(filteredDataColunmList, function (column) {
                if (_.includes(column?.displayName?.toLowerCase().trim(), searchedKey?.toLowerCase().trim()))
                    searchedColunmList.push(column);
            })
        }
        else {
            setSearchValue('');
            searchInputRef.current.value = '';
        }

        setFilterColumnsList(searchedColunmList);
    }

    const handleSearchOptionsButtonClick = (index) => {
        setSelectedSearchButton(index);
    };

    const executedData = (isSaveAndRun) => {
        setIsLoading(true);

        setState((prevState) => { return { ...prevState, isTestingConnection: true, restBody: JSON.stringify(filterData) } });
        resetErrorMessages();

        var cloudCollectionObject = state.cloudCollectionObjects.filter(obj => obj.templateCollectionId === state.templateCollectionId)[0];

        var hasDynamicColumn = selectedConnection.schemaSource === AppEnum.SchemaSource.hasDynamicColumn ? (state.collectionColumns && state.collectionColumns.length > 0 ? state.collectionColumns : null) : null;
        
        let testDataCollectionModal = {
            connectionUId: state.connectionUId,
            sysCollectionTypeId: state.sysCollectionTypeId,
            sourceName: state.sourceName,
            restRequestMethod: state.restRequestMethod,
            restRequestIsAsync: true,
            restSendAsCD: state.restSendAsCD,
            collectionParameters: isSearchOptionsAvailable ? searchOptionsParameters : state?.collectionParameters,
            collectionColumns: hasDynamicColumn ? hasDynamicColumn : preview ? state?.collectionColumnSchema?.filter((i) => i.isSelected) : columnsList?.filter((i) => i.isSelected),
            uId: state.uId,
            returnFlatternData: !cloudCollectionObject?.returnRawData,
            sourceNamePart4: state.sourceNamePart4,
            templateCollectionId: state.templateCollectionId,
            collectionFilters: getFilterData(),
            collectionSorts: sortData,
            collectionLimit: limitData,
            restDataTransformationScript : state?.restDataTransformationScript,
            returnRawData : cloudCollectionObject?.returnRawData,
            connectionId : selectedConnection?.id,
            flattenLikeSql: cloudCollectionObject?.flattenLikeSql || false,
            excludedProperties: cloudCollectionObject?.excludedProperties || "",
            selectedConnection: selectedConnection,
        }

        formateFilterData();
        testData(testDataCollectionModal,setData,null,null,true,setState,setIsLoading,true,null,null,null,state?.collectionColumnSchema ? state?.collectionColumnSchema?.filter(i => i.isDefault || i.isSelected) : state?.collectionColumns, formatColumList, setIsDynamicTestCollectionTested, handleSendDataToExcel, isSaveAndRun);

    };

    const handleOpenDialog = (selectColumn) => {
        let column = state?.collectionColumns.find(i=> i?.columnName == selectColumn?.columnName);
        let matchFormat = false;
        let displayFormatList = "";
        if(!column){
            column = columnsList?.find(i=> i?.columnName == selectColumn?.columnName);
            matchFormat = true;
        }
        else {
            let columnFromList = columnsList?.find(i => i?.columnName === selectColumn?.columnName);
            
            let basicCollectionColumnDataType = getEquivalentPriorityDataType(state?.displayFormatList, column?.dataTypeName);
            let basicColumnListDataType = getEquivalentPriorityDataType(state?.displayFormatList, columnFromList?.dataTypeName);

            if (columnFromList) {
                if (basicCollectionColumnDataType?.dataBaseDataType !== basicColumnListDataType?.dataBaseDataType && basicCollectionColumnDataType?.dataBaseDataType !== "Decimal") {
                    column = { ...column, dataTypeName: columnFromList?.dataTypeName, dataType: null, displayFormat: null };
                    matchFormat = true;
                }
            }
        }

        const listColumn  = columnsList?.find(i => i?.columnName === selectColumn?.columnName);
        if (column && listColumn && column.dataTypeName === AppEnum.DataBaseDataType.Int && listColumn.dataTypeName === AppEnum.DataBaseDataType.Long) {
            column = { ...column, dataTypeName: AppEnum.DataBaseDataType.Long, displayFormat: "" };

            let defaultInfo = getEquivalentPriorityDataType(state?.displayFormatList, column?.dataTypeName);
            let matchDataType =  prioritizeEquivalentDataTypes.find(i=> i?.sysDataTypeId == column?.dataType);

            let dataType = matchDataType ? defaultInfo?.sysDataTypeId : column?.dataType ;
            displayFormatList = state?.displayFormatList.filter(i => i.sysDataTypeId == dataType);
    
            column.dataType = defaultInfo?.sysDataTypeId;
            column.displayFormat = defaultInfo?.displayFormat;
        } 
        else {
            let defaultInfo = getEquivalentPriorityDataType(state?.displayFormatList, column?.dataTypeName);
            let matchDataType =  prioritizeEquivalentDataTypes.find(i=> i?.sysDataTypeId == column?.dataType);

            let dataType = matchDataType ? column?.dataType : defaultInfo?.sysDataTypeId;
            displayFormatList = state?.displayFormatList.filter(i => i.sysDataTypeId == dataType);

            if(matchFormat || !matchDataType){    
                let dataTypeCheck = displayFormatList?.find(i=> i.displayFormat == column.displayFormat);
                column.dataType = dataTypeCheck ? (column.dataType || defaultInfo?.sysDataTypeId) : defaultInfo?.sysDataTypeId;
                column.displayFormat = dataTypeCheck ? (column.displayFormat || defaultInfo?.displayFormat) : defaultInfo?.displayFormat;
            }
        }

        setCustomColumn(column);
        setDatatypeDisplayFormate(displayFormatList);
        setOpenPopup(true);
    }

    const onDisplayNameChange = (value) => {
        setCustomColumn((prevstate) => { return { ...prevstate, displayName: value } });
    };

    const onListClick =(value, field)=>{
        if(field){
            let list = state?.displayFormatList.filter(i => i.sysDataTypeId == value);
            setDatatypeDisplayFormate(list);
            setCustomColumn((prevstate) => { return { ...prevstate, dataTypeName: list[0]?.dataBaseDataType, dataType: value, displayFormat: list[0]?.displayFormat } });
        }
        else {
            setCustomColumn((prevstate) => { return { ...prevstate, displayFormat: value } });
        }
    }

    const onSaveClick =() =>{
        let count = 0;
        let newDisplayName = formatDisplayName(customColumn?.displayName);
        
        _.forEach(columnsList, function (col) {
            if (col?.displayName?.toLowerCase().trim() === newDisplayName?.toLowerCase().trim() && 
                col?.columnName?.toLowerCase().trim() !== customColumn?.columnName?.toLowerCase().trim()) {
                count++;
            }
        })

        if(count > 0){
            toast.error("Duplicate display names are not permitted");
            return;
        }

        _.forEach(columnsList, function (col) {
            if (col?.columnName?.toLowerCase().trim() === customColumn?.columnName?.toLowerCase().trim()) {
                _.set(col, 'dataType', customColumn?.dataType);
                _.set(col, 'displayFormat', customColumn?.displayFormat);
                _.set(col, 'displayName', newDisplayName);
                _.set(col, 'dataTypeName', customColumn?.dataTypeName);
            }
        }) 
        _.forEach(state?.collectionColumns, function (col) {
            if (col?.columnName?.toLowerCase().trim() === customColumn?.columnName?.toLowerCase().trim()) {
                _.set(col, 'dataType', customColumn?.dataType);
                _.set(col, 'dataTypeName', customColumn?.dataTypeName);
                _.set(col, 'displayFormat', customColumn?.displayFormat);
                _.set(col, 'displayName', newDisplayName);
            }
        })
        _.forEach(testedData?.transformedDataColunmsKey, function (col) {
            if (col?.columnName?.toLowerCase().trim() === customColumn?.columnName?.toLowerCase().trim()) {
                _.set(col, 'dataType', customColumn?.dataType);
                _.set(col, 'dataTypeName', customColumn?.dataTypeName);
                _.set(col, 'displayFormat', customColumn?.displayFormat);
                _.set(col, 'displayName', newDisplayName);
            }
        });
        
        setOpenPopup(false);
    }

    const handleClosePopup = (closeOnlyPopup) =>{
        setOpenPopup(false);
        if (!closeOnlyPopup) {
            setOpenDataScriptPopup(false)
        }
        // setCloudDataScriptType(null)
    }

    const handleAddCloudDataScriptPopup = (scriptType, isOpenPopUp, isScriptAlreadyApplied) => { 
        setCloudDataScriptType(scriptType)
        if (isOpenPopUp) {
            setOpenDataScriptPopup(true);
        }
        if (isScriptAlreadyApplied) {
            handleTestScript(null, scriptType);
        }
    }

    
    const handleTestScript = (script, scriptType, testedData, isRemovingColumns) => {
        try {
            const dataToTest = _.cloneDeep(state.testedDataList);
            let evalScript = null;

            if ((scriptType || cloudDataScriptType) == AppEnum.DataScript.dataTransformationScript) {

                if (!script && state?.dataTransformationScriptId) {
                    evalScript = preDefinedScriptsData?.find(i => i.id == state?.dataTransformationScriptId)?.script;
                    if (!evalScript) return;
                }
                else {
                    evalScript = script ? script : state.cloudDataTransformationScript; 
                }
                const dataTransformation = eval(`(${evalScript})`);
                let transformedData = dataTransformation(dataToTest);
    
                let testedDataTransformedColumnsKeys = transformedData?.[0];
                testedDataTransformedColumnsKeys = _.keys(testedDataTransformedColumnsKeys).filter(
                    (key) => !key.endsWith("-style")
                );

                if (!Array.isArray(transformedData)) {
                    toast.error("Warning: Transformed data is not an array.", transformedData);
                    return;
                }
                else if (Array.isArray(testedDataTransformedColumnsKeys) && transformedData?.length === 0) {
                    toast.error("Warning: Columns data is empty.");
                    return;
                }   
                const transformedColumns = getAfterTransformationColumnSchema(testedDataTransformedColumnsKeys, columnsList, state?.testedDataList, transformedData, isRemovingColumns);
                setIsSchemaChangedByScript(true);
    
                setTestedData((prevState) => { return { ...prevState, transformedData: transformedData, transformedDataColunmsKey: transformedColumns } });
                if((state?.dataTransformationScriptId) || state?.dataStylingScript) {
                    handleTestScript(null, AppEnum.DataScript.dataStylingScript, _.cloneDeep(transformedData));
                }
            }
            if ((scriptType || cloudDataScriptType) == AppEnum.DataScript.dataStylingScript){

                let dtsData = null;
                let transforMationScript = null;

                if (state?.dataTransformationScriptId) {
                    transforMationScript = preDefinedScriptsData?.find(i => i.id == state?.dataTransformationScriptId)?.script;
                    if (!transforMationScript) return;
                }
                else {
                    transforMationScript = state.cloudDataTransformationScript; 
                }
                if (transforMationScript) {
                    const dataTransformationScript = eval(`(${transforMationScript})`);
                    dtsData = dataTransformationScript(dataToTest);
                }
                if (!script && state?.dataStylingScriptId) {
                    evalScript = preDefinedScriptsData?.find(i => i.id == state?.dataStylingScriptId)?.script;
                    if (!evalScript) return;
                }
                else {
                    evalScript = script ? script : state.dataStylingScript ? state.dataStylingScript : defaultJavaScriptEditorValue; 
                }
                const dataStylingTransformation = eval(`(${evalScript})`);
                let transformedStyleData = dataStylingTransformation(testedData || dtsData || dataToTest);
    
                let testedDataStyledColumnsKeys = transformedStyleData?.[0];
                testedDataStyledColumnsKeys = _.keys(testedDataStyledColumnsKeys).filter(
                    (key) => !key.endsWith("-style")
                );

                if (!Array.isArray(transformedStyleData)) {
                    toast.error("Warning: Transformed Style Data is not an array.", transformedStyleData);
                    return;
                }
                else if (Array.isArray(testedDataStyledColumnsKeys) && transformedStyleData?.length === 0) {
                    toast.error("Warning: Columns data is empty.");
                    return;
                }
                const transformedColumns = getTransformedColumns(testedDataStyledColumnsKeys, columnsList, state?.testedDataList, isRemovingColumns);
                setTestedData((prevState) => { return { ...prevState, styleTransformedData: transformedStyleData, styleTransformedDataColunmsKey: transformedColumns } });
    
            }
        } catch (error) {
            console.error("Syntax error in the script:", error.message);
            toast.error(error.message);
            return;
        }
    }

    const handleRemoveTransformation = (scriptType) => {
        if (scriptType == AppEnum.DataScript.dataTransformationScript) {
            setState((prevState) => { return { ...prevState, cloudDataTransformationScript: null, dataTransformationScriptId: null } });
            setTestedData((prevState) => { return { ...prevState, transformedData: [], transformedDataColunmsKey: [] } });
            if((state?.dataTransformationScriptId) || state?.dataStylingScript) {
                handleTestScript(null, AppEnum.DataScript.dataStylingScript, _.cloneDeep(state?.testedDataList), true);
            }
        }
        else {
            setState((prevState) => { return { ...prevState, dataStylingScript: null, dataStylingScriptId : null } });
            setTestedData((prevState) => { return { ...prevState, styleTransformedData: [], styleTransformedDataColunmsKey: [] } });
        }
        setMuiDialog(false);
        setCloudDataScriptType(null);
    }

    const getCollectionScripts = () => {
        dataScriptService.getAllScript(true)
            .then((response) => {
                if (response?.data) {
                    setPreDefinedScriptsData(response?.data);
                }
            })
    }

    const confirmRemoveTransformation = (transforMationScriptType) =>{
        setCloudDataScriptType(transforMationScriptType);
        setMuiDialog(true);
    }

    const getTransformedColumns = (testedDataKeys, columnsList, rawData, isRemovingColumns) => {
        if (!testedDataKeys) return [];
      
        const selectedColumnsMap = (columnsList || [])
          .filter(({ isSelected }) => isSelected)
          .reduce((acc, { columnName, displayName }) => {
            acc[columnName] = displayName || columnName;
            return acc;
          }, {});
       
        const rawDataKeys = rawData?.length ? new Set(Object.keys(rawData[0])) : null;
      
        var selectedColumns = testedDataKeys
          .filter(key => selectedColumnsMap[key])
          .map(key => ({ columnName: key, displayName: selectedColumnsMap[key] }));
      
        const extraColumns = testedDataKeys
          .filter(key => !selectedColumnsMap[key] && (!rawDataKeys || !rawDataKeys.has(key)))
          .map(key => ({ columnName: key, displayName: key }));

          if (isRemovingColumns) {
            const nonAutoPopulatedColumns = (columnsList || []).filter(col => !col.isAutoPopulated);
            selectedColumns = selectedColumns.filter(
              sc => nonAutoPopulatedColumns.some(autoCol => autoCol.columnName === sc.columnName)
            );
            formatColumList(nonAutoPopulatedColumns);
          }
        
        return [...selectedColumns, ...extraColumns];
    };

    const handleSendDataToExcel= (response, isSaveAndRun) => {
        if (excelDataState?.isCommandFromExcel) {
            const responseData = response;
            setExcelDataState((prevState) => { return { ...prevState, parameters: searchOptionsParameters, data: responseData } });
            let dtScript = state?.cloudDataTransformationScript
            let dsScript = state?.dataStylingScript
            if (state?.dataTransformationScriptId) {
                dtScript = preDefinedScriptsData?.find(i => i.id == state?.dataTransformationScriptId)?.script;
            }
            if (state?.dataStylingScriptId) {
                dsScript = preDefinedScriptsData?.find(i => i.id == state?.dataStylingScriptId)?.script;
            }
            if (!excelDataState?.isEditMode) {
                // handleChangeObject();
                sendDataToWPF({ parameters: searchOptionsParameters, data: responseData, columns: state?.collectionColumnSchema, CloudDTScript: dtScript, DSScript: dsScript });
            }

            if (isSaveAndRun) {
                sendDataToWPF({ parameters: searchOptionsParameters, data: responseData, columns: state?.collectionColumnSchema, CloudDTScript: dtScript, DSScript: dsScript });
            }
        }
    }

    const sendDataToWPF = (data) => {
        if (window.chrome && window.chrome.webview) {
            window.chrome.webview.postMessage(JSON.stringify({ type: "send_data_to_excel", data }));
        }
    }

    const getAfterTransformationColumnSchema = (testedDataKeys, columnsList, rawData, transformedData, isRemovingColumns) => {
        if (!testedDataKeys) return [];

        var x = state;
      
        const selectedColumnsMap = (columnsList || [])
          .filter(({ isSelected }) => isSelected)
          .reduce((acc, column ) => {
            acc[column.columnName] = column;
            return acc;
          }, {});
      
        const rawDataKeys = rawData?.length ? new Set(Object.keys(rawData[0])) : null;

        var selectedColumns = testedDataKeys
          .filter(key => selectedColumnsMap[key])
          .map(key => ({ ...selectedColumnsMap[key] })); 
        
        if (selectedColumns.length === 0) {
            selectedColumns = Object.keys(selectedColumnsMap)
                .filter(key => testedDataKeys.includes(key))
                .map(key => ({ ...selectedColumnsMap[key] }));
        }

        const extraColumns = testedDataKeys
            .filter(key => (!selectedColumnsMap[key] && (!rawDataKeys || !rawDataKeys.has(key))))
            .map(key => {
                const matchedColumn = state?.collectionColumns?.find(column => column.columnName == key);
                return {
                    columnName: key,
                    displayName: matchedColumn?.displayName || key,
                    isSelected: true,
                    isAutoDeleted: false,
                    isAutoPopulated: true,
                    displayFormat: matchedColumn?.displayFormat,
                    dataTypeName: matchedColumn?.dataTypeName,
                }
            });
        
        var updatedColumns = (columnsList || [])
            .filter(col => !extraColumns.some(item => item.columnName === col.columnName))
            .map(col => {
                const inTested = testedDataKeys.indexOf(col.columnName) !== -1;
                const inRaw = rawDataKeys && rawDataKeys.has(col.columnName);

                const isAutoDeleted = (!inTested && inRaw)

                return {
                ...col,
                isAutoDeleted,
                isAutoPopulated: col.isAutoPopulated
                };
            });

        updatedColumns = updatedColumns.filter(col => {
            if (col.isAutoPopulated) {
                const isPresentInTestedDataKeys = testedDataKeys.includes(col.columnName);
                if (!isPresentInTestedDataKeys) {
                    return false;
                }
            }
            return true;
        });


        if (!isRemovingColumns) {
            updatedColumns = [...updatedColumns, ...extraColumns];
        } else {
            updatedColumns = (columnsList || [])
            .filter(col => !col.isAutoPopulated)
            .map(col => ({
                ...col,
                isAutoPopulated: false,
                isAutoDeleted: false,
            }));
        }

        updatedColumns.forEach(col => {
            const columnData = {
                [col.columnName]: (col.isAutoDeleted ? rawData : transformedData)?.map(row => row[col.columnName]) || []
            };
            const dataTypeObject = getDataTypeForObject(columnData);
            const dataType = getEquivalentDataTypes(dataTypeObject);
            col.dataTypeName = dataType[col.columnName];
        });

        if (updatedColumns?.length > 0) {
            formatColumList(updatedColumns);
        }
      
        return isRemovingColumns ? [...updatedColumns] : [...selectedColumns, ...extraColumns];
    };

    const getDataTypeForObject = (data) => {
        const dataTypes = {};
        const keyValues = {};
        if (!data) return {};

         data = [data];

         if (state.collectionColumnSchema) {
            let obj = data.find(item =>
                item && Object.keys(item).some(key => item[key] !== null)
            );
            
            for (const key in obj) {

                var firstNotNullValue = Object.values(obj)[0].find(i => i !== null);
                if (obj.hasOwnProperty(key)) {
                    const value = obj[key];
                    if (state.collectionColumnSchema) {
                        const column = state?.collectionColumns?.find(item => item.columnName === key) || state?.collectionColumnSchema?.find(item => item.columnName === key);
                        let baseType = getType(firstNotNullValue);
                        if (column && column.dataTypeName && (column.dataTypeName === baseType || column.dataTypeName === baseType.toLowerCase())) {
                            dataTypes[key] = column.dataTypeName
                        } 
                        else if (column && column.dataTypeName && baseType !== column.dataTypeName && column.dataTypeName == AppEnum.DataBaseDataType.Long) {
                            dataTypes[key] = column.dataTypeName;
                        } 
                        else if (baseType === AppEnum.DataBaseDataType.Int) {
                                let foundDecimal = Array.isArray(data[0][key]) && data[0][key].some(value => 
                                    value !== null && /^\d+\.\d+$/.test(value.toString())
                                );
                                
                                dataTypes[key] = foundDecimal ?  AppEnum.DataBaseDataType.Long : baseType;
                            }
                        else {
                            dataTypes[key] = baseType;
                        }
                    }
                    else {
                        dataTypes[key] = getType(firstNotNullValue);
                    }
                }
            }
        return dataTypes;
        }
    };

    const getType = (value) => {
        if (value === null) {
            return AppEnum.DataBaseDataType.String;
        }
        const type = Object.prototype.toString.call(value).slice(8, -1);
        if (type === AppEnum.DataBaseDataType.Number) {
            return Number.isInteger(value) ? AppEnum.DataBaseDataType.Int : AppEnum.DataBaseDataType.Long;
        }

        if (type === AppEnum.DataBaseDataType.String) {
            // Attempt to parse the value for various data types
            if (!isNaN(parseFloat(value)) && isFinite(value)) {
                return Number.isInteger(parseFloat(value)) ? AppEnum.DataBaseDataType.Int : AppEnum.DataBaseDataType.Long;
            }
            else if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
                return AppEnum.DataBaseDataType.Date;
            }
            else if (!isNaN(Date.parse(value))) {
                const parsedDate = new Date(value);
                if (!isNaN(parsedDate.getTime())) {
                    if (value.includes("T")) {
                        return AppEnum.DataBaseDataType.DateTime;
                    } else {
                        return AppEnum.DataBaseDataType.Date;
                    }
                }
            }else if (/^\d+$/.test(value)) {
                const byteValue = parseInt(value);
                if (!isNaN(byteValue) && byteValue >= 0 && byteValue <= 255) {
                    return AppEnum.DataBaseDataType.Byte;
                }
            } else if (/^\$?[0-9]+(\.[0-9]{1,2})?$/.test(value)) {
                return AppEnum.DataBaseDataType.Currency;
            }
        }
        return type;
    };

    const getEquivalentDataTypes = (originalDataTypes) => {
        return Object.keys(originalDataTypes)?.reduce((acc, key) => {
            const originalType = originalDataTypes[key];
            const highestPriorityType = DataTypePriorityMap[originalType?.toLowerCase()] || originalType;
            acc[key] = highestPriorityType;
            return acc;
        }, {});
    };

    return (
        <>
            <ColumnSelectionPopup columnsList={columnsList}
                rowData={state?.testedDataList}
                handleOnChangeSelectColumn={handleOnChangeSelectColumn}
                sortModal={sortModal}
                filterModal={filterModal}
                limitModal={limitModal}
                openSortModal={openSortModal}
                openFilterModal={openFilterModal}
                openLimitModal={openLimitModal}
                closeSortModal={closeSortModal}
                closeFilterModal={closeFilterModal}
                closeLimitModal={closeLimitModal}
                onChangeSortInputs={onChangeSortInputs}
                sortInput={sortInput}
                addSort={addSort}
                sortData={sortData}
                limitData={limitData}
                setLimitData={setLimitData}
                handleDeleteSort={handleDeleteSort}
                handleClickSort={handleClickSort}
                handleSave={handleSave}
                executeData={executeData}
                filterData={filterData}
                setFilterData={setFilterData}
                setSortData={setSortData}
                preview={preview}
                handleChangeObject={handleChangeObject}
                isLoading={isLoading}
                isDialogOpen={isDialogOpen}
                state={state}
                setState={setState}
                selectedConnection={selectedConnection}
                handleObjectChange={handleObjectChange}
                filterConfig={filterConfig}
                onSearchHandler={onSearchHandler}
                filterColumnsList={filterColumnsList}
                collectionFilterColumns={collectionFilterColumns}
                searchInputRef={searchInputRef}
                searchValue={searchValue}
                setColumnList={setColumnList}
                setIsColumnOrderChanged={setIsColumnOrderChanged}
                handleSearchOptionsButtonClick={handleSearchOptionsButtonClick}
                selectedSearchButton={selectedSearchButton}
                isSearchOptionsAvailable={isSearchOptionsAvailable}
                searchOptionsParameters={searchOptionsParameters}
                setSearchOptionsParameters={setSearchOptionsParameters}
                executedData={executedData}
                isOpenInDialog={isOpenInDialog}
                handleAuthorizeAgain={handleAuthorizeAgain}
                isAuthorizeAgain={isAuthorizeAgain}
                handleOpenDialog ={handleOpenDialog}
                openPopup={openPopup}
                handleClosePopup={handleClosePopup}
                onListClick={onListClick}
                onSaveClick={onSaveClick}
                onDisplayNameChange={onDisplayNameChange}
                customColumn={customColumn}
                datatypeDisplayFormate={datatypeDisplayFormate}
                handleAddCloudDataScriptPopup={handleAddCloudDataScriptPopup}
                openDataScriptPopup={openDataScriptPopup}
                setCloudDataScriptType={setCloudDataScriptType}
                cloudDataScriptType={cloudDataScriptType}
                handleTestScript={handleTestScript}
                testedData={testedData}
                handleRemoveTransformation={handleRemoveTransformation}
                preDefinedScriptsData={preDefinedScriptsData}
                prioritizeEquivalentDataTypes={prioritizeEquivalentDataTypes} 
                confirmRemoveTransformation={confirmRemoveTransformation}
                dataForStyleScript={dataForStyleScript}
                muiDialog={muiDialog}
                setMuiDialog={setMuiDialog}
                excelDataState={excelDataState}
                setIsParameterPopulated={setIsParameterPopulated}
                isParameterPopulated={isParameterPopulated}
                collectionTypeTemplate={collectionTypeTemplate}
                afterTransformationColumnKeys={state?.afterTransformationColumnKeys}/>
            {isDialogOpen &&
                <BasicInformationController
                    resetErrorMessages={resetErrorMessages}
                    state={state}
                    setState={setState}
                    prevStepRef={prevStepRef}
                    setSelectedConnection={setSelectedConnection}
                    isDialogOpen={isDialogOpen}
                    setIsDialogOpen={setIsDialogOpen}
                    saveCollection={handleSaveCollection}
                    isBasicInfoSubmitted={isBasicInfoSubmitted}
                    isUpdatingCollection={isUpdatingCollection}
                    isCloudLoading={isLoading}
                />}
        </>

    )
}
